import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { LanguageContext } from '../LanguageContext';

const NotFound = () => {
  const { t } = useContext(LanguageContext);
  return (
    <div className="page container">
      <header className="page__head">
        <p className="eyebrow">404</p>
        <h1>{t.notFound.title}</h1>
        <p>{t.notFound.text}</p>
      </header>
      <Link to="/" className="btn btn--dark">{t.notFound.button}</Link>
    </div>
  );
};

export default NotFound;
